import { useParams } from "react-router-dom";
import { CreatePayment } from "./components/CreatePayment";

export const AdminPayment = () => {
  const { batchId, paymentId } = useParams();

  return <CreatePayment paymentId={paymentId || ""} batchId={batchId || ""} />;
};
